<template>
  <div class="chart-container" ref="container">
    <div class="chart">
      <svg ref="svg"></svg>
    </div>
    <button @click="addRandomValue">添加随机数值</button>
  </div>
</template>

<script>
import * as d3 from 'd3';

export default {
  data() {
    return {
      data: [22, 34, 54], // 初始的数据数组
      containerWidth: 400, // 容器的宽度
      barWidth: 40, // 柱状条的宽度
      barSpacing: 10, // 柱状条之间的间距
      maxVisibleBars: 20 // 最大可见的柱状条数量
    };
  },
  mounted() {
    this.createChart();
    this.checkScroll();
    window.addEventListener('resize', this.checkScroll);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScroll);
  },
  methods: {
    createChart() {
      const container = this.$refs.container;
      d3.select(container)
          .style('width', `${this.containerWidth}px`);

      const svg = d3.select(this.$refs.svg)
          .attr('width', this.data.length * (this.barWidth + this.barSpacing))
          .attr('height', 200);

      const xScale = d3.scaleLinear()
          .domain([0, this.data.length - 1])
          .range([0, this.data.length * (this.barWidth + this.barSpacing) - this.barSpacing]);

      const yScale = d3.scaleLinear()
          .domain([0, d3.max(this.data)])
          .range([180, 0]);

      const bars = svg.selectAll('.bar')
          .data(this.data);

      bars.enter()
          .append('rect')
          .attr('class', 'bar')
          .merge(bars)
          .attr('x', (d, i) => xScale(i))
          .attr('y', d => yScale(d))
          .attr('width', this.barWidth)
          .attr('height', d => 180 - yScale(d));

      bars.exit().remove();
    },
    addRandomValue() {
      const randomValue = Math.floor(Math.random() * 31) + 20; // 生成介于 20 到 50 之间的随机数
      this.data.push(randomValue); // 将随机数添加到数据数组中
      this.updateChart(); // 更新图表
    },
    updateChart() {
      this.createChart(); // 创建新的图表
      this.checkScroll(); // 检查是否需要显示横向滚动条
    },
    checkScroll() {
      const container = this.$refs.container;
      const chartContainer = d3.select(container);
      const chartWidth = this.data.length * (this.barWidth + this.barSpacing);
      const containerWidth = container.clientWidth;

      if (chartWidth > containerWidth) {
        chartContainer.style('overflow-x', 'scroll');
      } else {
        chartContainer.style('overflow-x', 'hidden');
      }
    }
  }
};
</script>

<style>
.chart-container {
  width: 400px;
  height: 200px;
  overflow-x: hidden;
}

.chart {
  display: flex;
}
</style>
